export default __webpack_public_path__ + "static/media/Arm of the Great Bear.b81db359.jpg";